import React from 'react';
import Header from '../../components/Header';
import IconTool from '../../components/icons/IconTool';
import Card, { CardDescription, CardHeader } from '../../components/Card';
import IconCoupons from '../../components/icons/IconCoupons';
import IconInvoice from '../../components/icons/IconInvoice';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../routes/routes';
import IconReport from '../../components/icons/IconReport';

export default function Tools() {
    const history = useHistory();
    const handleClick = (type: keyof typeof ROUTES) => () => history.push(ROUTES[type]);

    return (
        <div className="p-4 w-full text-center">
            <Header>
                <IconTool className="inline w-6 mr-3" /> Tools
                <span className="text-lg font-light ml-3">Stripe Tools</span>
            </Header>
            <div className="p-4 grid grid-cols-1 md:grid-cols-4 gap-8">
                <Card>
                    <CardHeader onClick={handleClick('COUPONS')}>
                        <IconCoupons className="h-24 w-auto mx-auto pt-4" />
                    </CardHeader>
                    <CardDescription
                        title={
                            <button
                                onClick={handleClick('COUPONS')}
                                className="font-medium text-lg inline-block mb-2 hover:text-blue-400"
                            >
                                Bulk Coupon Generator
                            </button>
                        }
                    />
                </Card>
                <Card>
                    <CardHeader onClick={handleClick('INVOICES')}>
                        <IconInvoice className="h-24 w-auto mx-auto pt-4" />
                    </CardHeader>
                    <CardDescription
                        title={
                            <button
                                onClick={handleClick('INVOICES')}
                                className="font-medium text-lg inline-block mb-2 hover:text-blue-400"
                            >
                                Invoice PDF Generator
                            </button>
                        }
                    />
                </Card>
                <Card>
                    <CardHeader onClick={handleClick('INVOICES')}>
                        <IconReport className="h-24 w-auto mx-auto pt-4" />
                    </CardHeader>
                    <CardDescription
                        title={
                            <button
                                onClick={handleClick('USAGE_RECORDER')}
                                className="font-medium text-lg inline-block mb-2 hover:text-blue-400"
                            >
                                Subscription Usage Reporter
                            </button>
                        }
                    />
                </Card>
            </div>
        </div>
    );
}
